module.exports = __webpack_public_path__ + "img/icons-status-cancel.622010b0.svg";